(() => {
 const link=document.getElementById('vanity-whatsapp-help');
 if(!link)return;
 const key='vanity-whatsapp-edge-v2',margin=12;
 let start=null,dragged=false,suppressClick=false,resetTimer,saved=null;
 const bounds=()=>({x:Math.max(margin,innerWidth-link.offsetWidth-margin),y:Math.max(margin,innerHeight-link.offsetHeight-margin)});
 const place=(side,y)=>{
  const max=bounds(),top=Math.max(margin,Math.min(max.y,y));
  link.dataset.side=side;
  Object.assign(link.style,{left:side==='left'?margin+'px':'auto',top:top+'px',right:side==='right'?margin+'px':'auto',bottom:'auto'});
  return top;
 };
 const restore=()=>{
  if(!saved)return;
  const max=bounds();place(saved.side,margin+saved.y*(max.y-margin));
 };
 try{
  saved=JSON.parse(sessionStorage.getItem(key));
  if(!saved){
   const previous=JSON.parse(sessionStorage.getItem('vanity-whatsapp-position-v1'));
   if(previous&&Number.isFinite(previous.x)&&Number.isFinite(previous.y))saved={side:previous.x<0.5?'left':'right',y:previous.y};
  }
 }catch{}
 if(saved&&['left','right'].includes(saved.side)&&Number.isFinite(saved.y))restore();else saved=null;
 link.addEventListener('dragstart',e=>e.preventDefault());
 link.addEventListener('pointerdown',e=>{
  if(e.button!==0)return;
  clearTimeout(resetTimer);
  const r=link.getBoundingClientRect();
  start={x:e.clientX,y:e.clientY,top:r.top,id:e.pointerId};
  dragged=false;suppressClick=false;link.setPointerCapture(e.pointerId);
 });
 link.addEventListener('pointermove',e=>{
  if(!start||e.pointerId!==start.id)return;
  const dx=e.clientX-start.x,dy=e.clientY-start.y;
  if(!dragged&&Math.hypot(dx,dy)<6)return;
  dragged=true;e.preventDefault();
  place(e.clientX<innerWidth/2?'left':'right',start.top+dy);
 });
 const finish=e=>{
  if(!start||e.pointerId!==start.id)return;
  if(dragged){
   suppressClick=true;
   const max=bounds(),r=link.getBoundingClientRect();
   saved={side:link.dataset.side==='left'?'left':'right',y:(r.top-margin)/Math.max(1,max.y-margin)};
   try{sessionStorage.setItem(key,JSON.stringify(saved));}catch{}
   resetTimer=setTimeout(()=>{suppressClick=false;},400);
  }
  if(link.hasPointerCapture(e.pointerId))link.releasePointerCapture(e.pointerId);
  start=null;
 };
 link.addEventListener('pointerup',finish);
 link.addEventListener('pointercancel',finish);
 link.addEventListener('click',e=>{if(suppressClick){e.preventDefault();e.stopPropagation();suppressClick=false;}});
 window.addEventListener('resize',restore);
 let pageCount=1;
 try {
  pageCount=Number(sessionStorage.getItem('vanity-whatsapp-page-count-v1')||0)+1;
  sessionStorage.setItem('vanity-whatsapp-page-count-v1',String(pageCount));
 }catch{}
 const reveal=()=> {
  link.dataset.labelHidden='false';
  setTimeout(()=>{link.dataset.labelHidden='true';},5000);
 };
 if(pageCount===1)reveal();
 else if((pageCount-1)%3===0)setTimeout(reveal,800);
})();